const GroupingInputs = {
  BENCHMARKS: 'BENCHMARKS',
  BUCKETS: 'BUCKETS',
  NONLOOKTHRU_POSITIONS: 'NONLOOKTHRU_POSITIONS',
};

export default GroupingInputs;
